import * as React from 'react';

// useEnhancedEffect: A custom hook that uses useLayoutEffect in a browser environment
// and useEffect in other environments (e.g., server-side rendering).
const useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;

export default useEnhancedEffect;
